import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { StatsPage } from "@/features/domain/components/stats-page";
import { useI18n } from "@/providers/i18n-provider";

function StatsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Statistics`)}
      description={t(msg`Sign in to see attendance, membership and finance trends.`)}
    >
      <PageContainer maxWidth="3xl">
        <StatsPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const statsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/stats",
  component: StatsRoutePage,
});
